import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { routes } from "./routes";

export function PrivateRoute({ component: Component, authorized, ...props }) {
  return (
    <Route>
      {
        authorized ?
        <Component {...props} /> :
        <Redirect to={routes.LANDING} />
      }
    </Route>
  );
}
